import React, { Component } from 'react';
import './SolicitudCorrectivoLista.css';
import { FaArrowCircleLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';

import { getSolicitudesCorrectivosCliente, clearErrors } from '../../../redux/actions/dataactions';

export class SolicitudCorrectivoLista extends Component {
  constructor() {
    super();
    this.state = {
      errors: {},
      open: false,
      opendelete: false,
      idsolicitud: '',
      fechasolicitud: '',
      horasolicitud: '',
      numsolicitud: '',
      fallareportada: '',
      fecha: '',
      solicitud: {},
      tiemporespuesta: '',
      tiemporespuestahora: ''
    };
  }

  componentDidMount() {
    this.props.getSolicitudesCorrectivosCliente(this.props.match.params.clienteId);
  }

  render() {
    const { solicitudescorr, loadingsolcorr } = this.props.data;
const formatFecha = (value) => {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d)) return '';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
};

const formatHora = (value) => {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d)) return '';
  let h = d.getHours();
  const m = String(d.getMinutes()).padStart(2, '0');
  const ampm = h >= 12 ? 'pm' : 'am';
  h = h % 12;
  if (h === 0) h = 12;
  return `${String(h).padStart(2, '0')}:${m} ${ampm}`;
};

// Reemplaza tu const columns por este:
const columns = [
  {
    field: 'acciones',
    headerName: 'Acciones',
    width: 120,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => (
      <Tooltip title="Ver Perfil">
        <IconButton
          size="small"
          component={Link}
          to={`/dashboard/inventarioequiposasistencial/hojadevidaequipo/${params.row.equipoid}/${params.row.idprestador}`}
        >
          <ChevronRightIcon sx={{ color: '#03178C' }} />
        </IconButton>
      </Tooltip>
    )
  },

  // NUEVAS columnas derivadas de `datecreation`
  {
    field: 'fechasolicitud',
    headerName: 'Fecha',
    width: 130,
    valueGetter: (params) => params.row.datecreation,
    valueFormatter: (params) => formatFecha(params.value),
    sortComparator: (v1, v2) => new Date(v1) - new Date(v2) // ordena por fecha real
  },
  {
    field: 'horasolicitud',
    headerName: 'Hora',
    width: 120,
    valueGetter: (params) => params.row.datecreation,
    valueFormatter: (params) => formatHora(params.value)
  },

  { field: 'nombresolicita', headerName: 'Solicitante', width: 200 },
  { field: 'fallareportada', headerName: 'Falla', width: 340 },
  { field: 'estado', headerName: 'Estado', width: 140 }
];

    const rows = Array.isArray(solicitudescorr)
      ? solicitudescorr
          .slice()
          .sort((a, b) => new Date(b.datecreation) - new Date(a.datecreation))
          .map((row, index) => ({
            id:
              row.solicitudid ||
              row.idsolicitud ||
              row._id ||
              row.id ||
              `${row.equipoid || 'row'}-${index}`,
            ...row
          }))
      : [];

    const tableContent = !loadingsolcorr ? (
      <Box
        sx={{
          height: 500,
          width: '100%',
          mt: 2,
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: 'primary.main',
            color: 'white'
          }
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          disableRowSelectionOnClick
          initialState={{
            pagination: {
              paginationModel: { pageSize: 10 }
            }
          }}
          pageSizeOptions={[10, 25, 50]}
          components={{
            Toolbar: () => (
              <Box p={1}>
                <GridToolbarQuickFilter placeholder="Buscar..." />
              </Box>
            )
          }}
        />
      </Box>
    ) : (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
        <CircularProgress size={50} color="primary" />
      </Box>
    );

    return (
      <div>
        <div className="titulo_section">
          <div className="titulo_clientes">
            <h1 className="text-clientes">Solicitudes de Mantenimiento Correctivo</h1>
            <hr className="clientes_separator" />
          </div>

          <div className="div_boton">
            <Link to={`/dashboard/equiposasistencial`}>
              <Tooltip title="Volver">
                <IconButton size="small">
                  <FaArrowCircleLeft color="#03178C" size={20} />
                </IconButton>
              </Tooltip>
            </Link>
          </div>
        </div>

        <div className="div-tablacorr">{tableContent}</div>
      </div>
    );
  }
}

SolicitudCorrectivoLista.propTypes = {
  getSolicitudesCorrectivosCliente: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired
};

const mapActionsToProps = { getSolicitudesCorrectivosCliente, clearErrors };

const mapStateToProps = (state) => ({
  data: state.data,
  UI: state.UI
});

export default connect(mapStateToProps, mapActionsToProps)(SolicitudCorrectivoLista);